module.exports = __webpack_public_path__ + "img/jan-2.fe14a3a5.png";